function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { DateTime } from 'luxon';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { size4 } from '../../theme/scale';
import { z30 } from '../../theme/z-index';
import DropdownWrapper from '../dropdown-wrapper';
import MiniCalendar from '../mini-calendar';
const CalendarWrapper = styled.div`
  left: 0;
  margin-top: ${size4};
  position: absolute;
  z-index: ${z30};
`;
const dateToFormat = (date, format) => {
  const dt = DateTime.fromJSDate(date, {
    zone: Intl.DateTimeFormat().resolvedOptions().timeZone
  });
  const dtWoTz = DateTime.fromObject({
    year: dt.year,
    month: dt.month,
    day: dt.day,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
  }).toISO({
    includeOffset: false
  });
  if (!dtWoTz) return '';
  return DateTime.fromISO(dtWoTz.replace('Z', '')).toFormat(format);
};
export const DatePicker = ({
  value,
  onChange,
  placeholder,
  label,
  hint,
  errorMessage,
  highlightedDates,
  minDate,
  selectRange,
  size = 'md',
  maxDate,
  calendarLocale = 'en',
  dateFormat = 'ccc, LLL. d',
  highlightedDatesLabel,
  hideLabel = false,
  smallLabel = false,
  disabled = false,
  ...props
}) => {
  const formattedValue = useMemo(() => {
    if (!value) return '';
    if (Array.isArray(value)) {
      return value.map(val => dateToFormat(val, dateFormat)).join(' - ');
    }
    return dateToFormat(value, dateFormat);
  }, [dateFormat, value]);
  const selectionChanged = (value, closeMenu) => {
    onChange(value);
    if (!selectRange) closeMenu();
  };
  return /*#__PURE__*/React.createElement(DropdownWrapper, _extends({
    initialValue: value,
    label,
    placeholder,
    hint,
    errorMessage,
    hideLabel,
    smallLabel,
    disabled,
    formattedInputValue: formattedValue,
    closedIcon: "Calendar",
    openedIcon: "Calendar",
    clearOnFocus: false,
    readOnly: true
  }, props, {
    renderChildren: ({
      closeMenu
    }) => /*#__PURE__*/React.createElement(CalendarWrapper, null, /*#__PURE__*/React.createElement(MiniCalendar, {
      value: value,
      onChange: value => selectionChanged(value, closeMenu),
      highlightedDates: highlightedDates,
      highlightedDatesLabel: highlightedDatesLabel,
      selectRange: selectRange,
      minDate: minDate,
      maxDate: maxDate,
      closeCalendarMenu: closeMenu,
      locale: calendarLocale
    }))
  }));
};
export default DatePicker;
//# sourceMappingURL=index.js.map